import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import OtherEquipmentDetail from '../../components/other_equipments/OtherEquipmentDetail';
import { editOtherEquipment } from '../../redux/other_equipment/equipment_actions';
import { defaultRejectHandler } from '../../utils/utility';

class OtherEquipmentEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.otherEquipmentDetail = undefined;
    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  onSaveHandler() {
    const newEquipment = this.otherEquipmentDetail.getWrappedInstance().getOtherEquipmentData();
    this.props.editOtherEquipment({ ...newEquipment, id: this.props.otherEquipment.id });
  }

  render() {
    const { isEditing, errorMessage, otherEquipment, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('edit other equipment')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OtherEquipmentDetail
            otherEquipment={otherEquipment}
            ref={ref => (this.otherEquipmentDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="other-equipment-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  errorMessage: state.other_equipment.errorMessage,
  isEditing: state.other_equipment.isEditing,
});

const mapDispatchToProps = dispatch => ({
  editOtherEquipment: equipment =>
    defaultRejectHandler(
      dispatch(
        editOtherEquipment(equipment.id, equipment.name, equipment.power_required, equipment.description, equipment.image))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(OtherEquipmentEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/other_equipments/OtherEquipmentEditModal.js